import { ArrowDown } from '@phosphor-icons/react';

export default ArrowDown;
